import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { FileSignature } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { clearanceAPI } from '../../lib/clearanceAPI';
import { errText } from '../../lib/lettersAPI';

export const ClientAuthorityCard = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { clearanceAPI.myAuthorities().then(setRows).catch(() => {}); }, []);
  if (!rows.length) return null;
  const sign = async (id) => { try { window.location.href = (await clearanceAPI.mySign(id)).url; } catch (e) { toast.error(errText(e)); } };
  return (
    <Card data-testid="client-authority-card"><CardContent className="p-4 space-y-2">
      <p className="font-medium flex items-center gap-2"><FileSignature className="w-4 h-4" />Authority to contact your previous accountant</p>
      {rows.map((r) => (
        <div key={r.case_id} className="flex items-center justify-between gap-2 text-sm" data-testid={`client-authority-${r.case_id}`}>
          <span>{r.previous_accountant || 'Previous accountant'} · {r.reference}</span>
          {r.status === 'pending' ? <Button size="sm" onClick={() => sign(r.case_id)} data-testid={`client-authority-sign-${r.case_id}`}>Review &amp; sign</Button>
            : <span className="text-emerald-700 text-xs">Signed – a copy is in your Documents</span>}
        </div>))}
    </CardContent></Card>
  );
};
